import { CoreIcon } from '../core-icon';
import timerSVG from '../../assets/icons/timer.svg';
import type { IconProps } from '../core-icon';

export const TimerIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={timerSVG} {...props} />;
};
